import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Modal } from 'antd';
import { Button } from '@cropler/ui-kit';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

import styles from './styles.module.scss';
import { ReactComponent as LogoIcon } from '../../assets/images/logoSidebar.svg';

import {
  BreakpointMobile,
  BreakpointMobileUp,
  BreakpointTablet,
  ModalWidthSmall,
} from '../../constants/ui';
import { MoreMenu, NavItem } from './index.jsx';
import MoreMenuItem from './MoreMenuItem.jsx';
import { getSidebarLinksMap } from '../../utils/ui';

const Nav = ({ widthViewport }) => {
  const { t } = useTranslation();
  const SidebarLinksMap = getSidebarLinksMap(t);
  const Links =
    widthViewport > BreakpointMobile
      ? {
          part1: ['sensors', 'soilSensor', 'map', 'crops', 'scoring'],
          part2: ['fields', 'devices', 'team'],
        }
      : { part1: ['sensors', 'soilSensor', 'map', 'scoring'], partDropdown: ['fields', 'devices', 'team'] };

  const { selectedDate } = useSelector((state) => state.sensors);
  const [moreMenuOpen, setMoreMenuOpen] = useState(false);

  const closeMoreMenu = () => {
    setMoreMenuOpen(false);
  };

  const openMoreMenu = () => {
    setMoreMenuOpen(true);
  };

  return (
    <>
      <nav className={styles.nav}>
        {/*Logo*/}
        {widthViewport > BreakpointTablet && (
          <div className={styles.navLogo}>
            <div className={styles.navLogoIcon}>
              <LogoIcon />
            </div>
            Cropler
          </div>
        )}

        {/*Menu*/}
        <ul className={styles.menu}>
          {Links.part1.map((link) => {
            const { Icon, title, titleMobile, url } = SidebarLinksMap[link];
            return (
              <NavItem
                key={link}
                title={title}
                titleMobile={titleMobile}
                link={url}
                Icon={Icon}
                selectedDate={selectedDate}
                widthViewport={widthViewport}
                // isNew={link === 'soilSensor'}
              />
            );
          })}
          <li className={styles.menuSeparator}></li>
          {Links.part2 &&
            Links.part2.map((link) => {
              const { Icon, title, titleMobile, url } = SidebarLinksMap[link];
              return (
                <NavItem
                  key={link}
                  title={title}
                  titleMobile={titleMobile}
                  link={url}
                  Icon={Icon}
                  selectedDate={selectedDate}
                  widthViewport={widthViewport}
                  // isNew={link === 'soilSensor'}
                />
              );
            })}
          {widthViewport < BreakpointMobileUp && Links.partDropdown && (
            <li className={styles.menuItem}>
              <Button className={styles.menuLink} onClick={openMoreMenu}>
                <span className={styles.menuLinkIcon}>
                  <CroplerIcon name="more" />
                </span>
                {t('nav.more')}
              </Button>
            </li>
          )}
        </ul>

        {/*Footer*/}
        {widthViewport > BreakpointTablet && (
          <div className={styles.navFooter}>
            <Link to="mailto:hello@cropler.io" className={styles.menuLink}>
              <span className={styles.menuLinkIcon}>
                <CroplerIcon name="email" />
              </span>
              {t('nav.support')}
            </Link>
          </div>
        )}
      </nav>

      {Links.partDropdown && widthViewport < BreakpointMobileUp && (
        <Modal open={moreMenuOpen} onCancel={closeMoreMenu} footer={false} centered width={ModalWidthSmall}>
          <MoreMenu>
            {Links.partDropdown.map((link) => {
              const { Icon, title, titleMobile, url } = SidebarLinksMap[link];
              return (
                <MoreMenuItem
                  key={link}
                  text={titleMobile ? titleMobile : title}
                  Icon={Icon}
                  pathname={url}
                  search={link === 'maps' ? `?date=${selectedDate}` : ''}
                  isNew={link === 'soilSensor'}
                  onClickLink={closeMoreMenu}
                />
              );
            })}
          </MoreMenu>
        </Modal>
      )}
    </>
  );
};

export default Nav;
